import {
    BaseScheduleRepeat,
    CheckInPreference,
    Experience,
    PurchaseCutoffCheckInValidation,
    Schedule,
    ScheduleCheckInValidation,
} from "types";

export enum CutoffRepeat {
    PURCHASE_CUTOFF = "purchase_cutoff",
}

export type CutoffScheduleRepeat = BaseScheduleRepeat | CutoffRepeat;

export interface CutoffFormValues {
    repeat: CutoffScheduleRepeat;
    duration?: string;
}

export type CutoffScheduleFormValues = Omit<Schedule, "repeat"> & CutoffFormValues;

export type CheckInWindowValidation = PurchaseCutoffCheckInValidation | ScheduleCheckInValidation;

export interface CheckInPreferenceFormValues extends CheckInPreference {
    multiCheckInEnabled: boolean;
    checkInWindowEnabled: boolean;
}

export interface ExperienceCheckInFormValues
    extends Pick<Experience, "firstCheckinExpirationOffset" | "purchaseExpirationOffset"> {
    checkInPreference: CheckInPreferenceFormValues | null;
}
